<template>
  <div>
    <div v-if="styleShow!='btn'" class="addPictureBookBtn" @click="openDialog">
      <i class="el-icon-plus"></i>
    </div>
    <div v-else>
      <el-button type="primary" @click="dialogVisible=true" :disabled="doWhatTemp==='view'">添加资源</el-button>
    </div>
    <el-dialog title="关联绘本" :visible.sync="dialogVisible" >
      <div>
        <el-form :inline="true" :model="formFuzzy" label-width="80px">
          <el-form-item label="资源名称:">
            <el-input v-model="formFuzzy.bookName" placeholder="输入书籍名称" style="width:120px"></el-input>
          </el-form-item>
          <el-form-item label="资源ID:">
            <el-input v-model="formFuzzy.bookId" placeholder="输入书籍ID" style="width:100px"></el-input>
          </el-form-item>
          <el-form-item label="品牌:">
            <el-select v-model="formFuzzy.bookBrand" clearable style="width:100px">
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQuery">搜索</el-button>
          </el-form-item>
        </el-form>
        <br />
        <el-table
          ref="multipleTable"
          :data="queryData"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" label="ID" align="center" width="100"></el-table-column>
          <el-table-column prop="name" label="资源名称" align="center" min-width="150" sortable></el-table-column>
          <el-table-column prop="type" label="分类" align="center" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.type==10">绘本</div>
            </template>
          </el-table-column>
          <el-table-column prop="brand" label="品牌" align="center" width="120">
            <template slot-scope="scope">
              <span>{{ (JSON.parse(scope.row.content)).brand}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="clevel" label="上下架状态" width="140" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.clevel==2">编辑中</span>
              <span v-if="scope.row.clevel==3">审核中</span>
              <span v-if="scope.row.clevel==5">已上架</span>
              <span v-if="scope.row.clevel==6">审核驳回</span>
              <span v-if="scope.row.clevel==4">审核通过</span>
              <span v-if="scope.row.clevel==0">已下架</span>
              
              
              <!-- <el-select v-model="scope.row.clevel" size="mini">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="dialogConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
export default {
  name: "AddPictureBook",
  components: {},
  data() {
    return {
      dialogVisible: false,
      formFuzzy: {
        bookId: "",
        bookName: "",
        bookBrand: "",
      },
      brandList: [],
      cpList: [],
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      multipleSelection: [],
      statusList: [
        {
          value: 2,
          label: "编辑中",
        },
        {
          value: 3,
          label: "审核中",
        },
        {
          value: 4,
          label: "审核通过",
        },
        {
          value: 5,
          label: "已上架",
        },
        {
          value: 6,
          label: "审核驳回",
        },
      ],
    };
  },
  created() {
    this.fetchBrandList();
    this.fetchQueryData();
  },
  props: {
    doWhatTemp: {
      type: String,
      default: "",
    },
    currCpId: {
      type: Number,
      defualt: null,
    },
    styleShow: {
      type: String,
      default: "",
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  methods: {
    fetchQueryData() {
      let params = {
        appId: this.$API.APPID,
        type: 10,
      };
      let cpid = [];
      console.log(this.currCpId);
      console.log(Number(this.currCpId));
      if (this.currCpId != 0 && !isNaN(this.currCpId)) {
        cpid.push(this.currCpId);
      } else {
        let cpList = JSON.parse(sessionStorage.getItem("cpList"));
        for (let i = 0; i < cpList.length; ++i) {
          cpid.push(cpList[i].id);
        }
      }
      params.dbId = cpid;
      if (this.formFuzzy.bookId != "") {
        let bookid = [];
        bookid.push(Number(this.formFuzzy.bookId));
        params.id = bookid;
      }
      if (this.formFuzzy.bookName != "") {
        params.name = this.formFuzzy.bookName;
      }
      if (this.formFuzzy.bookBrand != "") {
        let brandId = [];
        brandId.push(Number(this.formFuzzy.bookBrand));
        params.tagIds = brandId;
      }

      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/aries-api/resource/list", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            this.queryData = response.data.data.list;
            this.pageTotal = response.data.data.pager.total;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    fetchBrandList() {
      let temp = {
        appId: this.$API.APPID,
        pid: 23,
        showAll: 1,
      };
      this.$axios
        .post("/aries-api/tag/list", temp)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            this.brandList = response.data.data;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    onQuery() {
      this.fetchQueryData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchQueryData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchQueryData();
    },
    dialogConfirm() {
      this.$emit("resourseSel", this.multipleSelection);
      this.dialogVisible = false;
    },
    openDialog() {
      if (this.doWhatTemp != "view") {
        this.dialogVisible = true;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// AddPictureBook.vue?4cd4902c